<template>
  <div>
    <img :src="data[0].banner" width="100%" />
    <b-input-group prepend="Thông báo" class="mb-4 mt-2 mr-sm-2 mb-sm-0">
      <b-form-input
        id="inline-form-input-username"
        style="background-color: white; color: black"
        :placeholder="announce[0]"
        readonly
      ></b-form-input>
    </b-input-group>
    <div class="row mt-2">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5">
        <Sidebar />
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-7">
        <div v-for="(val, i) in data" :key="i" class="card">
          <Table :result="val" :layout="data[0]" />
          <!-- <Table2 :result="val" /> -->
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import "bootstrap/dist/css/bootstrap.min.css";

import Table from "./component/Table.vue";

import Sidebar from "./component/Sidebar.vue";
import Footer from "./Footer.vue";
export default {
  components: { Table, Sidebar, Footer },
  props: {},
  computed: {},
  created() {
    this.$http
      .get(`${process.env.VUE_APP_BACKEND_API_URL}/lotto/6`)
      .then(({ data }) => {
        this.data = data;
      })
      .catch((err) => {
        return err;
      });
    this.$http
      .get(`${process.env.VUE_APP_BACKEND_API_URL}/announce`)
      .then(({ data }) => {
        this.announce = data;
      })
      .catch((err) => {
        return err;
      });
  },
  data() {
    return {
      data: [],
      announce: null,
    };
  },
  methods: {},
};
</script>
<style>
</style>
